module.exports = __webpack_public_path__ + "img/cde.2f991d43.png";